window._ = require('lodash');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Echo from 'laravel-echo';
// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

// window.Echo = new Echo({
//     broadcaster: 'reverb',
//     key: process.env.MIX_REVERB_APP_KEY,
//     // wsHost: window.location.hostname,
//     wsHost: process.env.REVERB_HOST,
//     wsPort: process.env.MIX_REVERB_PORT || 80,
//     wssPort: process.env.MIX_REVERB_SSL_PORT || 443,
//     forceTLS: true,
//     enabledTransports: ['ws', 'wss'],
// });


